export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGIN_BLOCKED = 'LOGIN_BLOCKED';
export const LOGIN_FLAG_OFF = 'LOGIN_FLAG_OFF';
export const FACEBOOK_LOGIN_REQUEST = 'LOGIN_FACEBOOK_REQUEST';
export const LOGIN_WITH_FACEBOOK = 'LOGIN_WITH_FACEBOOK';
export const LOGOUT = 'LOGOUT';
export const REFRESH_LOGIN = 'REFRESH_LOGIN';
export const VERIFY_SIGNUP_REQUEST = 'VERIFY_SIGNUP_REQUEST';
export const VERIFY_SIGNUP_SUCCESS = 'VERIFY_SIGNUP_SUCCESS';
export const PASSWORD_CHANGE_EMAIL = 'PASSWORD_CHANGE_EMAIL';
export const INVALID_PASSWORD_CHANGE_EMAIL = 'INVALID_PASSWORD_CHANGE_EMAIL';
export const PASSWORD_CHANGE_REQUEST = 'PASSWORD_CHANGE_REQUEST';
export const PASSWORD_CHANGE_TOKEN_EXPIRED = 'PASSWORD_CHANGE_TOKEN_EXPIRED';
export const PASSWORD_CHANGED = 'PASSWORD_CHANGED';
export const PASSWORD_CHANGE_ERROR = 'PASSWORD_CHANGE_ERROR';
export const CURRENT_PASSWORD_INVALID = 'CURRENT_PASSWORD_INVALID';
export const PASSWORD_CHANGE_FAIL = 'PASSWORD_CHANGE_FAIL';

// signup
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_SUCCESS_FLAG_OFF = 'SIGNUP_SUCCESS_FLAG_OFF';
export const SIGNUP_FAILED = 'SIGNUP_FAILED';
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const DELETE_USER_PROFILE = 'DELETE_USER_PROFILE';
export const GET_SINGLE_USER = 'GET_SINGLE_USER';
export const BLOCKED_USER = 'BLOCKED_USER';
export const RESTORED_USER = 'RESTORED_USER';
export const REMOVED_USER = 'REMOVED_USER';
export const RESENT_EMAIL = 'RESENT_EMAIL';
export const USER_DESC_ORDER_BY_EMAIL = 'USER_DESC_ORDER_BY_EMAIL';
export const USER_ASC_ORDER_BY_EMAIL = 'USER_ASC_ORDER_BY_EMAIL';
export const USER_DESC_ORDER_BY_NAME = 'USER_DESC_ORDER_BY_NAME';
export const USER_ASC_ORDER_BY_NAME = 'USER_ASC_ORDER_BY_NAME';
export const USER_DESC_ORDER_BY_DATE = 'USER_DESC_ORDER_BY_DATE';
export const USER_ASC_ORDER_BY_DATE = 'USER_ASC_ORDER_BY_DATE';
export const USER_DESC_ORDER_BY_STATUS = 'USER_DESC_ORDER_BY_STATUS';
export const USER_ASC_ORDER_BY_STATUS = 'USER_ASC_ORDER_BY_STATUS';
export const SET_USERS_GROUP = 'SET_USERS_GROUP';
export const REMOVE_USERS_GROUP = 'REMOVE_USERS_GROUP';
export const USER_PLAN_CHANGE_SUCCESS = 'USER_PLAN_CHANGE_SUCCESS';
export const USER_PLAN_CHANGE_ERROR = 'USER_PLAN_CHANGE_ERROR';
export const RESET_PLAN_CHANGE_SUCCESS = 'RESET_PLAN_CHANGE_SUCCESS';
export const USER_DELETION_SCHEDULED = 'USER_DELETION_SCHEDULED';
export const USER_DELETION_CANCELLED = 'USER_DELETION_CANCELLED';
// signup end
// playlist
export const ADD_PLAYLIST_SUCCESS = 'ADD_PLAYLIST_SUCCESS';
export const ADD_PLAYLIST_FAILED = 'ADD_PLAYLIST_FAILED';
export const GET_PLAYLIST_SUCCESS = 'GET_PLAYLIST_SUCCESS';
export const GET_ONE_PLAYLIST = 'GET_ONE_PLAYLIST';
export const GET_PLAYLIST_REQUEST = 'GET_PLAYLIST_REQUEST';
export const GET_PLAYLIST_FAILED = 'GET_PLAYLIST_SUCCESS';
export const ADD_CONTENT_IN_PLAYLIST = 'ADD_CONTENT_IN_PLAYLIST';
export const ADD_SCREEN_TO_PLAYLIST = 'ADD_SCREEN_TO_PLAYLIST';
export const PLAYLIST_SCREEN_CHECK = 'PLAYLIST_SCREEN_CHECK';
export const DELETE_CONTENT_FROM_PLAYLIST = 'DELETE_CONTENT_FROM_PLAYLIST';
export const DELETE_PLAYLIST = 'DELETE_PLAYLIST';
export const UPDATE_DURATION = 'UPDATE_DURATION';
export const PLAYLIST_FLAG_OFF = 'PLAYLIST_FLAG_OFF';
export const EDIT_PLAYLIST_NAME = 'EDIT_PLAYLIST_NAME';
export const EDIT_PLAYLIST_DEMO_ATTRIBUTE = 'EDIT_PLAYLIST_DEMO_ATTRIBUTE';
export const UNCHECKED_TIME_LEBEL = 'UNCHECKED_TIME_LEBEL';
export const PLAYLIST_CONETNT_SORTING = 'PLAYLIST_CONTENT_SORTING';
export const UPDATE_PLAYLIST_OPTIONS_SUCCESS =
  'UPDATE_PLAYLIST_OPTIONS_SUCCESS';
export const UPDATE_PLAYLIST_OPTIONS_FAILED = 'UPDATE_PLAYLIST_OPTIONS_FAILED';
export const PLAYLIST_DUPLICATE_NAMES_ERROR = 'PLAYLIST_DUPLICATE_NAMES_ERROR';
// playlist end

// split screen
export const ADD_SPLITSCREEN_SUCCESS = 'ADD_SPLITSCREEN_SUCCESS';
export const ADD_SPLITSCREEN_FAILED = 'ADD_SPLITSCREEN_FAILED';
export const GET_SPLITSCREEN_SUCCESS = 'GET_SPLITSCREEN_SUCCESS';
export const DELETE_SPLITSCREEN = 'DELETE_SPLITSCREEN';
// split screen end

// content
export const ADD_CONTENT_REQUEST = 'ADD_CONTENT_REQUEST';
export const ADD_CONTENT = 'ADD_CONTENT';
export const EDIT_CONTENT = 'EDIT_CONTENT';
export const ADD_CONTENT_FAILED = 'ADD_CONTENT_FAILED';
export const ADD_CONTENT_DUPLICATE_ERROR = 'ADD_CONTENT_DUPLICATE_ERROR';
export const GET_CONTENT_SUCCESS = 'GET_CONTENT_SUCCESS';
export const GET_CONTENT_FAILED = 'GET_CONTENT_FAILED';
export const CONTENT_DELETE_REQUEST = 'CONTENT_DELETE_REQUEST';
export const CONTENT_DELETE_SUCCESS = 'CONTENT_DELETE_SUCCESS';
export const CONTENT_FLAG_OFF = 'CONTENT_FLAG_OFF';
export const CONTENT_MOVE_TO_FOLDER = 'CONTENT_MOVE_TO_FOLDER';
export const CONTENT_DESC_ORDER_BY_CREATEDAT =
  'CONTENT_DESC_ORDER_BY_CREATEDAT';
export const CONTENT_ASC_ORDER_BY_CREATEDAT = 'CONTENT_ASC_ORDER_BY_CREATEDAT';
export const CONTENT_DESC_ORDER_BY_NAME = 'CONTENT_DESC_ORDER_BY_NAME';
export const CONTENT_ASC_ORDER_BY_NAME = 'CONTENT_ASC_ORDER_BY_NAME';
export const CHECKED_CONTENT = 'CHECKED_CONTENT';
export const UNCHECKED_CONTENT = 'UNCHECKED_CONTENT';
export const CHECKED_SINGLE_CONTENT = 'CHECKED_SINGLE_CONTENT';
export const UNCHECKED_SINGLE_CONTENT = 'UNCHECKED_SINGLE_CONTENT';
export const DELETE_BULK_CONTENT = 'DELETE_BULK_CONTENT';
export const RESTORE_FILES_REQUEST = 'RESTORE_FILES_REQUEST';
export const RESTORE_FILES_SUCCESS = 'RESTORE_FILES_SUCCESS';
export const GET_CONTENT_FROM_GOOGLE_DRIVE = 'GET_CONTENT_FROM_GOOGLE_DRIVE';
export const PICKING_DATA_FROM_GOOGLE = 'PICKING_DATA_FROM_GOOGLE';
export const PICKED_DATA_FROM_GOOGLE = 'PICKED_DATA_FROM_GOOGLE';
export const UPLOAD_FAILED = 'UPLOAD_FAILED';
export const CONTENT_MOVE_REQUEST = 'CONTENT_MOVE_REQUEST';
export const CONTENT_MOVE_SUCCESS = 'CONTENT_MOVE_SUCCESS';
export const CONTENT_MOVE_FAILED = 'CONTENT_MOVE_FAILED';
export const CONTENT_FOLDER_PULL_SUCCESS = 'CONTENT_FOLDER_PULL_SUCCESS';
export const CONTENT_FOLDER_PULL_FAILED = 'CONTENT_FOLDER_PULL_FAILED';
export const GET_PLAYLISTS_BY_CONTENT_SUCCESS =
  'GET_PLAYLISTS_BY_CONTENT_SUCCESS';
export const GET_PLAYLISTS_BY_CONTENT_FAILED =
  'GET_PLAYLISTS_BY_CONTENT_FAILED';
export const EDIT_WIDGET = 'EDIT_WIDGET';
export const EDIT_WIDGET_FAILED = 'EDIT_WIDGET_FAILED';
export const CLOSE_WIDGET_SYNC_PROMPT = 'CLOSE_WIDGET_SYNC_PROMPT';
export const SYNC_WIDGET_SCREENS_FAILED = 'SYNC_WIDGET_SCREENS_FAILED';
export const DUPLICATE_NAMES_ERROR = 'DUPLICATE_NAMES_ERROR';
export const CONTENT_MOVE_ERROR = 'CONTENT_MOVE_ERROR';

// content end
// screen
export const SCREEN_REGISTER = 'SCREEN_REGISTER';
export const SCREEN_REGISTER_FLAG_OFF = 'SCREEN_REGISTER_FLAG_OFF';
export const GET_ALL_SCREEN_SUCCESS = 'GET_ALL_SCREEN_SUCCESS';
export const GET_ONE_SCREEN = 'GET_ONE_SCREEN';
export const SCREEN_STATUS_ACTIVE = 'SCREEN_STATUS_ACTIVE';
export const SCREEN_STATUS_DEACTIVE = 'SCREEN_STATUS_DEACTIVE';
export const DELETE_SCREEN = 'DELETE_SCREEN';
export const DELETE_SCREEN_REQUEST = 'DELETE_SCREEN_REQUEST';
export const EDIT_SCREEN = 'EDIT_SCREEN';
export const SCREEN_MOVE_TO_FOLDER = 'SCREEN_MOVE_TO_FOLDER';
export const SCREEN_PAIRED = 'SCREEN_PAIRED';
export const SCREEN_UNPAIRED = 'SCREEN_UNPAIRED';
export const SCREEN_NO_DATA_LOGS = 'SCREEN_NO_DATA_LOGS';
export const SET_ASAP_UPDATE_FAILED = 'SET_ASAP_UPDATE_FAILED';
export const SET_PENDING_STATUS_FAILED = 'SET_PENDING_STATUS_FAILED';
export const SCREEN_DUPLICATE_NAMES_ERROR = 'SCREEN_DUPLICATE_NAMES_ERROR';
export const GET_SCREEN_DETAILS_ERROR = 'GET_SCREEN_DETAILS_ERROR';
export const SCREEN_ERROR = 'SCREEN_ERROR';
export const SCREEN_UPDATE_V2 = 'SCREEN_UPDATE_V2';
// screen end
// apk
export const FETCH_APK_REQUEST = 'FETCH_APK_REQUEST';
export const FETCH_APK_SUCCESS = 'FETCH_APK_SUCCESS';
export const ADD_APK = 'ADD_APK';
export const ADD_APK_SUCCESS = 'ADD_APK_SUCCESS';
export const APK_ALREADY_SAVED = 'APK_ALREADY_SAVED';
export const APK_INDENTITY = 'APK_INDENTITY';
export const APK_FLAG_OFF = 'APK_FLAG_OFF';
export const APK_DELETE = 'APK_DELETE';
export const GET_LATEST_APK = 'GET_LATEST_APK';
// screens stats
export const GET_DAY_SCREEN_DATA_USAGE_STATS =
  'GET_DAY_SCREEN_DATA_USAGE_STATS';
export const GET_DAY_SCREEN_DATA_USAGE_STATS_FAIL =
  'GET_DAY_SCREEN_DATA_USAGE_STATS_FAIL';
export const GET_PERIOD_SCREEN_DATA_USAGE_STATS_FAIL =
  'GET_PERIOD_SCREEN_DATA_USAGE_STATS_FAIL';
export const GET_PERIOD_SCREEN_DATA_USAGE_STATS_SUCCESS =
  'GET_PERIOD_SCREEN_DATA_USAGE_STATS_SUCCESS';
export const GET_SCREENS_STATS_RANKING_SUCCESS =
  'GET_SCREENS_STATS_RANKING_SUCCESS';
export const GET_SCREENS_STATS_RANKING_FAIL = 'GET_SCREENS_STATS_RANKING_FAIL';
export const GET_SCREEN_STAT_RANKING_DETAILS =
  'GET_SCREEN_STAT_RANKING_DETAILS';
export const GET_SCREEN_STAT_RANKING_DETAILS_FAIL =
  'GET_SCREEN_STAT_RANKING_DETAILS_FAIL';
export const GET_TWENTY_DAYS_USER_STATS = 'GET_TWENTY_DAYS_USER_STATS';
export const GET_USER_RANKING = 'GET_USER_RANKING';
export const GET_USER_RANKING_FAILED = 'GET_USER_RANKING_FAILED';
export const GET_INTERNET_USAGE_PER_USER = 'GET_INTERNET_USAGE_PER_USER';
// apk end
// file folder
export const CREATE_FOLDER = 'CREATE_FOLDER';
export const GET_FOLDERS = 'GET_FOLDERS';
export const SET_FOLDER_ID = 'SET_FOLDER_ID';
export const CHANGE_FOLDER = 'CHANGE_FOLDER';
export const FOLDER_FLAG_OFF = 'FOLDER_FLAG_OFF';
export const FOLDER_DELETE = 'FOLDER_DELETE';
export const EDIT_FOLDER = 'EDIT_FOLDER';
export const CREATE_FOLDER_FAIL = 'CREATE_FOLDER_FAIL';
export const FOLDER_DUPLICATE_NAMES_ERROR = 'FOLDER_DUPLICATE_NAMES_ERROR';
// group
export const CREATE_GROUP = 'CREATE_GROUP';
export const GET_GROUPS = 'GET_GROUPS';
export const SET_GROUP_ID = 'SET_GROUP_ID';
export const CHANGE_GROUP = 'CHANGE_GROUP';
export const GROUP_FLAG_OFF = 'GROUP_FLAG_OFF';
export const GROUP_DELETE = 'GROUP_DELETE';
export const EDIT_GROUP = 'EDIT_GROUP';
export const SET_GROUPS = 'SET_GROUPS';
// email
export const EMAIL_TEMP_SAVE = 'EMAIL_TEMP_SAVE';
export const EMAIL_TEMP_GET = 'EMAIL_TEMP_GET';
export const EDIT_TEMP_EMAIL = 'EDIT_TEMP_EMAIL';
export const EMAIL_OFF_TEMP = 'EDIT_OFF_TEMP';
// email end

//plans
export const CHANGE_PLAN_FEATURE = 'CHANGE_PLAN_FEATURE';
export const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS';
export const GET_PLAN_SUCCESS = 'GET_PLAN_SUCCESS';
export const CHANGE_PLAN_FEATURE_DRAFT = 'CHANGE_PLAN_FEATURE_DRAFT';
export const SAVE_PLANS_FEATURES = 'SAVE_PLANS_FEATURES';
export const SEARCH_PLANS = 'SEARCH_PLANS';
export const CLEAN_DRAFT = 'CLEAN_DRAFT';
export const LIST_FEATURES_LOCKS_SUCCESS = 'LIST_FEATURES_LOCKS_SUCCESS';
export const SET_FEATURES_LOCKS_SUCCESS = 'SET_FEATURES_LOCKS_SUCCESS';
export const SET_FEATURES_LOCKS_FAIL = 'SET_FEATURES_LOCKS_FAIL';
export const SET_FEATURES_LOCKS_LOADING = 'SET_FEATURES_LOCKS_LOADING';
export const GET_ONLY_PRICES = 'GET_ONLY_PRICES';

//Widgets grid
export const PENDING_WIDGETS_GRID = 'PENDING_WIDGETS_GRID';
export const INIT_WIDGETS_GRID = 'INIT_WIDGETS_GRID';
export const EDIT_WIDGETS_GRID = 'EDIT_WIDGETS_GRID';
export const DELETE_WIDGETS_GRID = 'DELETE_WIDGETS_GRID';
export const ADD_WIDGET_TO_GRID = 'ADD_WIDGET_TO_GRID';
export const EDIT_WIDGET_IN_GRID = 'EDIT_WIDGET_IN_GRID';
export const DELETE_WIDGET_FROM_GRID = 'DELETE_WIDGET_FROM_GRID';
export const UPDATE_WIDGETS_IN_GRID = 'UPDATE_WIDGETS_IN_GRID';
export const GET_DASHBOARD_STATS = 'GET_DASHBOARD_STATS';

//logs
export const GET_LOGS_SUCCESS = 'GET_LOGS_SUCCESS';

//user notes
export const GET_NOTES_SUCCESS = 'GET_NOTES_SUCCESS';
export const SAVE_NOTE = 'SAVE_NOTE';
export const DELETE_NOTE = 'DELETE_NOTE';

// products
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const CREATE_PRICE = 'CREATE_PRICE';
export const EDIT_PRODUCT = 'EDIT_PRODUCT';
export const EDIT_PRICE = 'EDIT_PRICE';
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCTS_PRICES = 'GET_PRODUCTS_PRICES';
export const ATTACH_PRODUCT_SUCCESS = 'ATTACH_PRODUCT_SUCCESS';
export const GET_ADDITIONAL_FEATURES_SUCCESS =
  'GET_ADDITIONAL_FEATURES_SUCCESS';

export const GET_PRICE_FOR_PRODUCT = 'GET_PRICE_FOR_PRODUCT';
export const PRODUCTS_FAIL = 'PRODUCTS_FAIL';
export const UPDATE_PLAN_PRODUCT_IDS = 'UPDATE_PLAN_PRODUCT_IDS';
export const RESET_PRODUCTS_DATA = 'RESET_PRODUCTS_DATA';

// subscription
export const GET_SUBSCRIPTION_DETAILS_SUCCESS =
  'GET_SUBSCRIPTION_DETAILS_SUCCESS';
export const GET_SUBSCRIPTION_DETAILS_ERROR = 'GET_SUBSCRIPTION_DETAILS_ERROR';
export const UPADTE_CUSTOMER_DETAILS = 'UPADTE_CUSTOMER_DETAILS';
export const UPDATE_CUSTOMER_PM = 'UPDATE_CUSTOMER_PM';
export const GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD =
  'GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD';
export const GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD_FAIL =
  'GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD_FAIL';

// scheduler
export const GET_SCHEDULERS_SUCCESS = 'GET_SCHEDULERS_SUCCESS';
export const SHOW_ERROR = 'SHOW_ERROR';
export const CREATE_SCHEDULER = 'CREATE_SCHEDULER';
export const EDIT_SCHEDULER = 'EDIT_SCHEDULER';
export const REMOVE_SCHEDULER = 'REMOVE_SCHEDULER';
export const ADD_EVENT = 'ADD_EVENT';
export const DELETE_EVENTS_PAIR = 'DELETE_EVENTS_PAIR';
export const EDIT_EVENT_PAIR = 'EDIT_EVENT_PAIR';
export const MOVE_PAIR = 'MOVE_PAIR';
export const COPY_PAIR = 'COPY_PAIR';

// notifications
export const NOTIFICATIONS_FETCH_REQUEST = 'NOTIFICATIONS_FETCH_REQUEST';
export const NOTIFICATIONS_FETCH_SUCCESS = 'NOTIFICATIONS_FETCH_SUCCESS';
export const NOTIFICATIONS_FETCH_FAIL = 'NOTIFICATIONS_FETCH_FAIL';
export const NOTIFICATIONS_MARK_READ = 'NOTIFICATIONS_MARK_READ';
export const NOTIFICATIONS_MARK_ALL_READ = 'NOTIFICATIONS_MARK_ALL_READ';
export const NOTIFICATIONS_DELETE = 'NOTIFICATIONS_DELETE';
export const NOTIFICATIONS_CREATE = 'NOTIFICATIONS_CREATE';
